import {GeofenceRecord as _GeofenceRecord} from '../../../shared-models/public/geofence-record';

export class GeofenceRecord extends _GeofenceRecord{
}

export namespace GeofenceRecord{
    export import RestTypes=_GeofenceRecord.RestTypes;
}